<template>
  <div class="student-tag">
    <studentTagTopBar
      ref="topBar"
      @addShow="addShowType"
      @editShow="editShowType"
      @checkAllType="checkAllType"
      @delbatch="delbatch"
      :batchBtnShowType="batchBtnShow"
      :cancelBtnShowType="cancelBtnShow"
      @search="search"
    />
    <studentTagItem
      :studentTagData="studentTagData"
      :getListResult="getListResult"
      :editShow="editShow"
      @reviseShowType="reviseShowType"
      @reviseTag="reviseTag"
      @delTag="delTag"
      :checkAll="checkAll"
      @deleteBatchList="deleteBatchList"
      @tagBindStudentListDialogShow="tagBindStudentListDialogShowChange"
    />
    <!-- 添加弹出框 -->
    <studentTagAdd
      :dialogVisible.sync="addShow"
      :gradeExamInfoList="gradeExamInfoList"
      :schoolGradeData="schoolGradeData"
      v-show="addShow"
      @tagStudentSubmit="tagStudentSubmit"
      @tagStudentSelectSubmit="tagStudentSelectSubmit"
    />
    <!-- 修改弹出框 -->
    <studentTagRevise
      :dialogVisible.sync="reviseShow"
      :gradeExamInfoList="gradeExamInfoList"
      v-show="reviseShow"
    />
    <!-- 标签绑定学生列表弹窗 -->
    <tagBindStudentListDialog
      :tagBindStudentListDialogShow.sync="tagBindStudentListDialogShow"
      :tagBindStudentList="tagBindStudentList"
      v-show="tagBindStudentListDialogShow"
    />
  </div>
</template>

<script>
import studentTagTopBar from "./components/student-tag-topBar/studentTagTopBar.vue";
import studentTagItem from "./components/student-tag-item/student-tag-item.vue";
import studentTagAdd from "./components/student-tag-add/student-tag-add.vue";
import studentTagRevise from "./components/student-tag-revise/student-tag-revise.vue";
import tagBindStudentListDialog from "./components/bind-student-list-dialog/bindStudentListDialog.vue";

export default {
  components: {
    studentTagTopBar,
    studentTagItem,
    studentTagAdd,
    studentTagRevise,
    tagBindStudentListDialog,
  },
  data() {
    return {
      studentTagData: [],
      getListResult: "nullData",
      addShow: false,
      reviseShow: false,
      editShow: "",
      checkAll: false, //
      deleteBatchLists: [], // 批量删除列表
      delArr: [],
      batchBtnShow: false,
      cancelBtnShow: false,
      searchTag: "",
      gradeExamInfoList: [], // 考试列表
      schoolGradeData: [], // 年级列表
      tagBindStudentList: [], // 标签绑定学生列表
      tagBindStudentListDialogShow: false, // 标签绑定学生列表弹窗
    };
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.getGradeList();
    this.getSchoolExamInfoByTeacher();
    this.getStudentTagData();
  },
  watch: {
    // 状态切换
    classify: {
      handler(val) {
        if (val) {
          // console.log("watch=>",val);
          this.studentTagData = null;
          this.getStudentTagData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 点击标签展示绑定学生列表
    tagBindStudentListDialogShowChange(e) {
      this.tagBindStudentList = e;
      this.tagBindStudentListDialogShow = true;
    },
    // 查询年级班级
    getGradeList() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.getgradeList, data).then((res) => {
        // console.log("获取年级班级列表==>", res);
        this.schoolGradeData = res.data;
      });
    },
    // 添加标签-筛选
    tagStudentSubmit(data) {
      this.post(this.$url.addLabelCondition, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg || "添加失败");
        this.$message.success(res.msg || "添加成功");
        this.addShow = false;
        // 刷新列表
        this.refresh();
      });
    },
    // 添加标签-选择学生
    tagStudentSelectSubmit(data) {
      this.post(this.$url.batchAddLabelCondition, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg || "添加失败");
        this.$message.success(res.msg || "添加成功");
        this.addShow = false;
        // 刷新列表
        this.refresh();
      });
    },
    // 获取年级考试信息列表
    getSchoolExamInfoByTeacher() {
      let data = {
        schoolId: this.user.schoolId,
        pageSize: 10000,
        pageNum: 1,
      };
      this.get(this.$url.getSchoolExamInfoByTeacher, data).then((res) => {
        // console.log("获取年级考试信息列表", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取年级考试列表失败");
        this.gradeExamInfoList = res.rows;
      });
    },
    // 搜索
    search(e) {
      this.searchTag = e;
      this.getStudentTagData();
    },
    // 批量删除
    delbatch(e) {
      if (!this.delArr.length) {
        return this.$message.warning("请先选择需要删除的标签");
      }
      this.$confirm("是否删除选中的标签?", "删除标签", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {})
        .catch(() => {});
    },
    // 批量删除列表
    deleteBatchList(e) {
      this.delArr = e;
    },
    // 全选
    checkAllType(e) {
      this.checkAll = e;
    },
    // 单个删除
    delTag(e) {
      this.delete(this.$url.delLabelCondition + "/" + e.id)
        .then((res) => {
          // console.log(res);
          if (res.code == 200 && res.data != 0) {
            this.$message.success(res.msg);
            // 刷新列表
            this.refresh();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err);
          this.$message.error(res.msg);
        });
    },
    // 修改的标签
    reviseTag(e) {
      console.log(e);
    },
    // 标签状态管理
    editShowType(e) {
      this.studentTagData.map((item) => {
        item.remark = e;
        return;
      });
    },
    // 添加框显示
    addShowType(e) {
      // console.log(e);
      this.addShow = e;
    },
    reviseShowType(e) {
      this.reviseShow = e;
    },
    // 刷新
    refresh() {
      this.studentTagData = [];
      this.getStudentTagData();
      this.$refs.topBar.batchBtnShow = false;
      this.$refs.topBar.cancelBtnShow = false;
    },
    // 获取标签
    getStudentTagData() {
      let data = {
        schoolId: this.user.schoolId,
        // gradeId: 110,
        labelName: this.searchTag,
      };
      // this.getListResult = "loading";
      this.post(this.$url.getLabelConditionList, data).then((res) => {
        // console.log("获取学生标签列表：", res);
        if (res.code !== 200) {
          this.getListResult = "error";
          return this.$message.error(res.msg);
        }
        this.studentTagData = res.data;
        this.getListResult = res.data.length ? "success" : "nullData";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementStudentTag.scss";
</style>